module.exports = __webpack_public_path__ + "assets/25958f3798dc96f2455719470972c537.png";